import React, { useRef, useState, useEffect } from 'react';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import 'photoswipe/dist/photoswipe.css';
import { motion } from "framer-motion";
import { Link, useNavigate } from 'react-router-dom';
export default function StripStoriesCarousel(props) {
    var fields = props.fields, storyId = props.storyId, storiesListing = props.storiesListing;
    //const TitleTag = (fields.preTitleTag || 'h4') as keyof JSX.IntrinsicElements;
    var _a = useState([]), similarStories = _a[0], setSimlarStories = _a[1];
    var splideRef = useRef(null);
    var navigate = useNavigate();
    //useEffect(() => {
    //    setSimilarStories(storyId);
    //}, []);
    useEffect(function () {
        setSimStories(storyId);
    }, [storyId]);
    var setSimStories = function (id) {
        if (storiesListing && storiesListing.length > 0) {
            var finalArr = void 0;
            var simStories = storiesListing.filter(function (item) { return item.id != id; });
            console.log(simStories);
            finalArr = simStories;
            var selectedCategory = sessionStorage.getItem('selectedCategory');
            var parsedSelectedCategory_1 = selectedCategory ? JSON.parse(selectedCategory) : [];
            if (parsedSelectedCategory_1 && parsedSelectedCategory_1.length > 0) {
                finalArr = simStories.filter(function (item) {
                    for (var i = 0; i < item.categories.length; i++) {
                        if (item.categories[i].key == parsedSelectedCategory_1[0]) {
                            return item;
                        }
                    }
                });
            }
            setSimlarStories(finalArr);
        }
    };
    var storyDetails = function (item, j) {
        return (React.createElement(React.Fragment, { key: j },
            React.createElement(motion.div
            //initial={{ opacity: 0 }}
            //whileInView={{ opacity: 1 }}
            //viewport={{ once: true, margin: "-20%" }}
            , { 
                //initial={{ opacity: 0 }}
                //whileInView={{ opacity: 1 }}
                //viewport={{ once: true, margin: "-20%" }}
                className: "row" },
                React.createElement(Link, { className: "story-details mb-5 col", tabIndex: 0, to: item.url ? item.url : "#" },
                    item.fields.cardImage && React.createElement("div", { className: "story-image" },
                        React.createElement("img", { src: item.fields.cardImage, width: 250, title: item.fields.title, alt: item.fields.cardImage_description, className: "img-fluid card-img", itemProp: "image" })) || null,
                    item.categories && item.categories.length > 0 && React.createElement("div", { className: "story-category" },
                        React.createElement("div", { className: "h6", title: item.categories[0].value }, item.categories[0].value.toUpperCase())) || null,
                    item.fields.title && React.createElement("div", { className: "story-title" },
                        React.createElement("div", { className: "display-5 font1", title: item.fields.title, itemProp: "headline" }, item.fields.title)) || null,
                    item.fields.cardAbstract && React.createElement("div", { className: "story-content", dangerouslySetInnerHTML: { __html: item.fields.cardAbstract } }) || null))));
    };
    return (React.createElement(React.Fragment, null, similarStories && similarStories.length > 0 &&
        React.createElement(motion.div, { initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true, margin: "-20%" } },
            React.createElement(Splide, { hasTrack: false, "aria-label": "My Favorite Images", options: {
                    rewind: true,
                    //type: 'loop',
                }, ref: splideRef, className: "strip sky23-featured-carousel splide text-moss container-fluid " },
                React.createElement("div", { className: "similar-stories-title" },
                    React.createElement("h2", { className: "title-similar", title: "Similar Stories" }, "MORE STORIES LIKE THIS")),
                React.createElement("div", { className: "row g-0 featured-items-carousel-wrapper", itemScope: true, itemType: "https://schema.org/ItemList" },
                    React.createElement("div", { className: "col featured-carousel-items-col text-stone" },
                        React.createElement(SplideTrack, null, similarStories && similarStories.length > 0 && similarStories.map(function (item, j) {
                            return (React.createElement(SplideSlide, { key: j, itemProp: "itemListElement", itemScope: true, itemType: "https://schema.org/Article" }, storyDetails(item, j)));
                        })))))) || null));
}
